import React from "react";
import styled from "styled-components";
import { ConfigProvider, Input } from "antd";

const CustomInput = styled(Input)`
  border-radius: ${(props) => props.borderradius || "0.25rem"};
  border-color: ${(props) => props.borderColor || "var(--input-border-color)"};
  background-color: ${(props) => props.backgroundcolor || "transparent"};
  color: ${(props) => props.color || "var(--black)"};
  padding: ${(props) => props.padding || "0.5rem"};
  font-size: ${(props) => props.fontsize || "1.125rem"};
  font-weight: ${(props) => props.fontWeight || "var(--font-100)"};
  letter-spacing: ${(props) => props.letterSpacing || "0rem"};
  opacity: ${(props) => props.opacity || "1"};
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  max-width: ${(props) => props.maxWidth || "100%"};
  max-height: ${(props) => props.maxHeight || "100%"};
`;

export const SimpleInput = (props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#21223d",
        },
      }}
    >
      <CustomInput {...props}>{props.children}</CustomInput>
    </ConfigProvider>
  );
};
